// simple debounce function to delay the processing of an event
export const debounce = (func, wait) => {
  let timeout

  const debouncedFunction = function (...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }

  debouncedFunction.cancel = () => {
    clearTimeout(timeout)
  }

  return debouncedFunction
}
